import { render, staticRenderFns } from "./TermsOfUseAcceptanceModal.vue?vue&type=template&id=0b6c4d10&scoped=true"
import script from "./TermsOfUseAcceptanceModal.vue?vue&type=script&lang=ts"
export * from "./TermsOfUseAcceptanceModal.vue?vue&type=script&lang=ts"
import style0 from "./TermsOfUseAcceptanceModal.vue?vue&type=style&index=0&id=0b6c4d10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6c4d10",
  null
  
)

export default component.exports